import { IMealPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { ITakeMealtSearch, ITakeMealtDetial } from "./takeMealtTypes"
class TakeMealtServices {
    async page(searchVo: ITakeMealtSearch) {
        const apiUrl = "/takeout/statistics";
        return await httpRequest.post<IMealPage<ITakeMealtDetial>>(apiUrl, searchVo);
    }
    async export(searchVo: ITakeMealtDetial) {
        const apiUrl = "/takeout/statistics/export";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo);
    }
}
export const takeMealtServices = new TakeMealtServices();
